// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"91fd8601","422":"5c6946bb","627":"133a5ab7","905":"20c9a343","923":"89a9a76e"}[chunkId] + ".chunk.js";
};